// src/app/components/create-token-modal/create-token-modal.component.ts
import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-create-token-modal',
  templateUrl: './create-token-modal.component.html',
})
export class CreateTokenModalComponent {
  token = { Name: '', Expiry: new Date() };
  partnerId = '';

  constructor(public activeModal: NgbActiveModal) {}

  save(): void {
    this.activeModal.close({Name: this.token.Name, Expiry: this.token.Expiry, partnerId: this.partnerId});
  }

  cancel(): void {
    this.activeModal.dismiss();
  }

  onDateSelect(event: any) {
    this.token.Expiry = event
  }

}
